import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';
import { isEditableRow } from '_legacy/modules/shared/columns/tools/headingTools';

export const getNearForwardTypes = () => {
    return ['', 'Near', 'Forward'];
};

const nearForwardHeading = {
    colId: 'nearForward',
    headerName: 'Near/Forward',
    field: 'nearForward',
    editable: isEditableRow,
    cellEditorFramework: SelectEditor,
    hide: true,
    cellEditorParams: {
        valuesByDataset: getNearForwardTypes,
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    width: 120,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
};

export default nearForwardHeading;
